import toaAxios from 'api/axios';
import config from 'config';

export async function searchUsersAndGroupsFromGraph(searchString: string) {
	const url = `${config.apiBaseUri}users/${searchString}/graph`;
	const result = await toaAxios.get(url);
	return result.data;
}

export async function searchUsersFromGraph(searchString: string) {
	const url = `${config.apiBaseUri}usersOnly/${searchString}/graph`;
	const result = await toaAxios.get(url);
	return result.data;
}
